import { IntegratedCircuitChipIcon } from './IntegratedCircuitChipIcon';

/**
 * author: Jeff Anders
 * id D9D79C34-BE5A-4EA2-BB40-07E941C1632B
 * name integrated-circuit-chip
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/integrated-circuit-chip.svg
 * tags
 * - Banking 
 */
export const IccIcon = IntegratedCircuitChipIcon;
export default IccIcon